import { render, staticRenderFns } from "./PromptLibraryWidget.vue?vue&type=template&id=2e1ccb55"
import script from "./PromptLibraryWidget.vue?vue&type=script&lang=js"
export * from "./PromptLibraryWidget.vue?vue&type=script&lang=js"
import style0 from "./PromptLibraryWidget.vue?vue&type=style&index=0&id=2e1ccb55&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports